import { defineComponent as _defineComponent } from 'vue'
import { useInterval } from '@/composables/misc';
import { isNil } from '@/utils/misc';
import { computed, shallowRef } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeZoneIndicator',
  props: {
    timeZone: null
  },
  setup(__props: any) {

const props = __props as {
  timeZone: string | null;
};



const now = shallowRef<Date>(new Date());

useInterval(() => (now.value = new Date()), 60);

const name = computed<string>(() => props.timeZone ?? '-');

const time = computed<string>(() => {
  if (isNil(props.timeZone)) {
    return '-';
  }

  return Intl.DateTimeFormat(
    undefined, // browser default
    { hour: 'numeric', minute: 'numeric', timeZone: props.timeZone },
  ).format(now.value);
});

return { __sfc: true,props, now, name, time }
}

})